import { css } from 'aphrodite';
import * as React from 'react';
import { AiButton } from '../../../components-v2/AiButton';
import { SuccessCheckIcon } from '../../../components/svgs/icons/SuccessCheckIcon';
import { getResourceConfig } from './resourceConfig';
import { s } from './styles';
import { ResourceStatus, ResourceType } from './types';

export interface ResourceCardProps {
	status: ResourceStatus;
	sourceType?: ResourceType;
	onGenerate?: () => void;
}

export interface LegacyResourceCardProps {
	type: ResourceType;
	sourceType?: ResourceType;
	isCompleted?: boolean;
	scheduledDate?: Date;
	onGenerate?: () => void;
}

const convertLegacyProps = (props: LegacyResourceCardProps): ResourceCardProps => {
	const status: ResourceStatus = {
		type: props.type,
		isCompleted: props.isCompleted || false,
		scheduledDate: props.scheduledDate,
	};

	return {
		status,
		sourceType: props.sourceType,
		onGenerate: props.onGenerate,
	};
};

export const ResourceCard: React.FC<ResourceCardProps | LegacyResourceCardProps> = props => {
	const isNewAPI = 'status' in props;
	const normalizedProps = isNewAPI
		? (props as ResourceCardProps)
		: convertLegacyProps(props as LegacyResourceCardProps);

	const { status, sourceType, onGenerate } = normalizedProps;
	const config = getResourceConfig(status.type);
	const completedStatusLabel = config.completedStatusLabel || 'Scheduled successfully';

	const iconStyles = [
		s.aiCardRowIcon,
		status.type === 'email'
			? s.emailIconBackground
			: status.type === 'social'
				? s.socialIconBackground
				: s.blogIconBackground,
	];

	const cardStyles = [s.aiCardRow];

	const getDescription = (): string => {
		if (sourceType) {
			return config.createDescription(sourceType);
		}

		return config.description;
	};

	return (
		<div className={css(...cardStyles)}>
			<div className={css(...iconStyles)}>
				<img src={config.iconPath} alt={config.title} className={css(s.aiCardRowImage)} />
			</div>

			<div className={css(s.aiCardContent)}>
				<div className={css(s.aiCardTitle)}>{config.title}</div>
				<div className={css(s.aiCardDescription)}>{getDescription()}</div>

				{status.isCompleted ? (
					<div className={css(s.completedStatus)}>
						<SuccessCheckIcon className={css(s.completedStatusIcon)} />
						<span>{completedStatusLabel}</span>
					</div>
				) : (
					onGenerate && (
						<div className={css(s.aiCardButtonContainer)}>
							<AiButton title={config.buttonText} onClick={onGenerate} size='sm' />
						</div>
					)
				)}
			</div>
		</div>
	);
};
